import { render, staticRenderFns } from "./Plant.vue?vue&type=template&id=5dc2e9f0&scoped=true&"
import script from "./Plant.vue?vue&type=script&lang=js&"
export * from "./Plant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2e9f0",
  null
  
)

export default component.exports